module.exports = __webpack_public_path__ + "static/media/hand-shake-ii.5cbb8762.svg";